import { ref } from 'vue';
import { Role } from '@/entities/role';

export const useRoleRecord = () => ref<Role>({
  title: '',
  users: [],
  permissions: [],
  scimRoleIdentifier: null,
  entityItemRestricted: false,
});
